/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useAdminLayoutStyles = makeStyles<Theme, { drawerWidth: number }>((theme: Theme) => ({
  root: {
    display: 'flex',
    background: '#FFFFFF',
    wordBreak: 'break-word',
  },
  drawerHeader: {
    display: 'flex',
    flex: '0 0 76px',
    alignItems: 'center',
    padding: '0 8px',
    minHeight: '76px',
    justifyContent: 'flex-end',
  },
  content: {
    display: 'flex',
    // overflow: "hidden",
    flexDirection: 'column',
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: ({ drawerWidth }) => -drawerWidth,
    minHeight: '100vh',
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: '0 !important',
  },
  contentBox: {
    flex: 1,
    padding: '20px 20px',
  },
  verticalTabsContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  verticalTabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: 200,
    '& .MuiTab-root': {
      minHeight: 48,
      justifyContent: 'flex-start',
      padding: '12px 24px',
      textTransform: 'none',
      '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
      },
    },
  },
  verticalTabsContent: {
    flex: 1,
    padding: theme.spacing(3),
    overflow: 'auto',
  },
}));
